import script from './script'

const workerDataScript = () => {
    return { script }
}
export default workerDataScript